@use './shared' as *;

.joy-stepper {
    @include defaultStyle();
}
